import RestService, {ErrorDetails, ResponseStatus, RestCall} from "./restService";
import EnvironmentService from "./environmentService";
import {
    FriendRequestDto,
    UpdateUsernameRequestDto,
    ChangePasswordRequestDto,
    FriendRequestResponseDto,
    AcceptFriendRequestDto,
    RejectFriendRequestDto,
    UpdateIconRequestDto,
    InviteFriendRequestDto,
} from "../model/functionModels";

async function addFriend(request: FriendRequestDto,
                         onSuccess: () => Promise<any>,
                         onFailure: (a: string) => Promise<any>,
                         onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/friends`,
            method: "post",
            body: request,
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed adding friend!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function updateUsername(request: UpdateUsernameRequestDto,
                              onSuccess: () => Promise<any>,
                              onFailure: (a: string) => Promise<any>,
                              onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me`,
            method: "patch",
            body: request,
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed updating username!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function changePassword(request: ChangePasswordRequestDto,
                            onSuccess: () => Promise<any>,
                            onFailure: (a: string) => Promise<any>,
                            onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/password`,
            method: "patch",
            body: request,
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed changing password!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function getPendingFriendRequests(onSuccess: (requests: FriendRequestResponseDto[]) => Promise<any>,
                                       onFailure: (a: string) => Promise<any>,
                                       onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/friend-requests`,
            method: "get",
        } as RestCall,
        async (response: ResponseStatus) => {
            const requests = response.body as FriendRequestResponseDto[];
            await onSuccess(requests);
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed getting friend requests!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function acceptFriendRequest(request: AcceptFriendRequestDto,
                                 onSuccess: () => Promise<any>,
                                 onFailure: (a: string) => Promise<any>,
                                 onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/friend-requests/${request.requestId}/accept`,
            method: "post",
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed accepting friend request!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function rejectFriendRequest(request: RejectFriendRequestDto,
                                  onSuccess: () => Promise<any>,
                                  onFailure: (a: string) => Promise<any>,
                                  onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/friend-requests/${request.requestId}/reject`,
            method: "post",
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed rejecting friend request!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function updateIcon(request: UpdateIconRequestDto,
                         onSuccess: () => Promise<any>,
                         onFailure: (a: string) => Promise<any>,
                         onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me`,
            method: "patch",
            body: request,
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed updating icon!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function inviteFriend(request: InviteFriendRequestDto,
                            onSuccess: () => Promise<any>,
                            onFailure: (a: string) => Promise<any>,
                            onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/friends/invitations`,
            method: "post",
            body: request,
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed inviting friend!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function removeFriend(friendId: string,
                            onSuccess: () => Promise<any>,
                            onFailure: (a: string) => Promise<any>,
                            onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/friends/${friendId}`,
            method: "delete",
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed removing friend!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function deleteMyAccount(onSuccess: () => Promise<any>,
                               onFailure: (a: string) => Promise<any>,
                               onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me`,
            method: "delete",
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed deleting account!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function exportMyData(onSuccess: (data: any) => Promise<any>,
                            onFailure: (a: string) => Promise<any>,
                            onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/export`,
            method: "get",
        } as RestCall,
        async (response: ResponseStatus) => {
            await onSuccess(response.body);
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed exporting user data!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

const FriendService = {
    addFriend,
    updateUsername,
    updateIcon,
    inviteFriend,
    removeFriend,
    deleteMyAccount,
    exportMyData,
    changePassword,
    getPendingFriendRequests,
    acceptFriendRequest,
    rejectFriendRequest,
};

export default FriendService;

